import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { FinishChatbotPageRoutingModule } from "./finish-chatbot-routing.module";
import { FinishChatbotPage } from "./finish-chatbot.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FinishChatbotPageRoutingModule,
  ],
  declarations: [FinishChatbotPage],
})
export class FinishChatbotPageModule {}
